const rules = {
  user: {
    static: ['dashboard:visit', 'profile:visit', 'profile:update'],
  },
  admin: {
    static: [
      'kucing:visit',
      'disc:visit',
      'peoplem:visit',
      'team:list',
      'team:create',
      'team:edit',
      'team:delete',
      'team:visit',
      'office:list',
      'office:create',
      'office:edit',
      'office:delete',
      'office:visit',
      'user:list',
      'user:create',
      'user:edit',
      'user:delete',
      'user:visit',
      'dashboard:visit',
      'profile:visit',
      'profile:update',
      'cover:visit',
    ],
  },
  dev: {
    static: [
      'kucing:visit',
      'disc:visit',
      'peoplem:visit',
      'project:list',
      'project:create',
      'project:edit',
      'project:delete',
      'project:visit',
      'projectCategory:list',
      'projectCategory:create',
      'projectCategory:edit',
      'projectCategory:delete',
      'projectCategory:visit',
      'team:list',
      'team:create',
      'team:edit',
      'team:delete',
      'team:visit',
      'office:list',
      'office:create',
      'office:edit',
      'office:delete',
      'office:visit',
      'user:list',
      'user:create',
      'user:edit',
      'user:delete',
      'user:visit',
      'dashboard:visit',
      'profile:visit',
      'profile:update',
      'cover:visit',
    ],
  },
  cover: {
    static: ['cover:visit'],
  },
};

export default rules;
